<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="title"
    width="30%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          label="课程名称"
          prop="courseName"
        >
          <el-input v-model="createForm.courseName" />
        </el-form-item>
        <el-form-item
          label="证书编号"
          prop="certNo"
        >
          <el-input v-model="createForm.certNo" />
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';

export default {
  name: 'CourseOffline',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      title: '新建课程类型',
      cancelText: '取消',
      createForm: {
        id: null,
        courseName: null,
        certNo: null,
      },
      creatRules: {
        courseName: [
          { required: true, message: '请输入课程名称', trigger: 'blur' },
        ],
        certNo: [
          { required: true, message: '请输入证书编号', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    item(val) {
      if (val) {
        const {
          courseName,
          certNo,
          id,
        } = val;
        this.createForm = {
          courseName,
          certNo,
          id,
        };
      }
    },
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.createForm.clearValidate();
        });
      }
    },
  },
  methods: {
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const data = await axClient.cert.offlineCourseUpsert(this.createForm);
          if (!data) return;
          if (this.createForm.id) {
            this.$message.success('修改线下课程成功');
          } else {
            this.$message.success('新增线下课程成功');
          }
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
  .wx-info {
    padding: 0 0 0 0;
    text-align: left;
    .item {
      margin-bottom: 15px;
      span {
        font-size: 12px;
        color: $--base-color-black;
        &:last-child {
          padding-left: 8px;
        }
      }
    }
  }
}

</style>
